import React from 'react';
import { Instagram, MessageCircle, MapPin, Clock } from 'lucide-react';
export function Footer() {
  return <footer id="contacto" className="relative border-t border-white/10 bg-[#050505] pt-20 pb-10 overflow-hidden" data-id="element-112">
      {/* Top Neon Border Line */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-neon-violet to-transparent opacity-50" data-id="element-113" />

      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-114">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-115">
          {/* Brand */}
          <div data-id="element-116">
            <div className="flex items-center gap-2 mb-6" data-id="element-117">
              <div className="w-2 h-2 rounded-full bg-neon-green shadow-[0_0_10px_rgba(74,222,128,0.8)]" data-id="element-118" />
              <span className="font-display text-3xl tracking-wider text-white" data-id="element-119">
                NINJA 2.0
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs" data-id="element-120">
              Elevando el arte del cabello al siguiente nivel. Cortes de autor y
              colorimetría avanzada por Nicolas Marshall.
            </p>
          </div>

          {/* Location & Booking */}
          <div data-id="element-121">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-122">
              Ubicación & Horarios
            </h4>
            <ul className="space-y-4" data-id="element-123">
              <li className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-124">
                <MapPin size={18} className="text-neon-violet shrink-0 mt-0.5" data-id="element-125" />
                <span data-id="element-126">Calle El Pinar, Canelones, Uruguay</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-127">
                <Clock size={18} className="text-neon-green shrink-0 mt-0.5" data-id="element-128" />
                <span data-id="element-129">Atención exclusiva con agenda previa.</span>
              </li>
            </ul>

            <a href="https://wa.me/59899999999" target="_blank" rel="noreferrer" className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-neon-violet to-neon-green text-white font-semibold text-sm hover:scale-105 transition-transform shadow-[0_0_20px_rgba(168,85,247,0.2)]" data-id="element-130">
              <MessageCircle size={18} data-id="element-131" />
              Por otras consultas Escríbenos
            </a>
          </div>

          {/* Social */}
          <div data-id="element-132">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-133">
              Conecta
            </h4>
            <div className="flex gap-4" data-id="element-134">
              <a href="https://instagram.com/barberianinja2.0" target="_blank" rel="noreferrer" className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-white/10 hover:text-neon-violet hover:border-neon-violet/50 transition-all" data-id="element-135">
                <Instagram size={20} data-id="element-136" />
              </a>
              <a href="https://wa.me/59899999999" target="_blank" rel="noreferrer" className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-white/10 hover:text-neon-green hover:border-neon-green/50 transition-all" data-id="element-137">
                <MessageCircle size={20} data-id="element-138" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-139">
          <p className="text-gray-500 text-sm" data-id="element-140">
            © 2026 Barbería Ninja 2.0 — Nicolas Marshall.
          </p>
          <p className="text-gray-600 text-xs" data-id="element-141">
            Diseñado para el Siguiente Nivel.
          </p>
        </div>
      </div>
    </footer>;
}